import { NOTIFICATION } from 'config/notifications'
import { notificationHooks } from 'features/notifications'
import { appConnector } from 'shared/connector'

import { api } from '../api'
import { useCurrent } from './current'

export function useAddContacts() {
	const snack = notificationHooks.useSnack()

	const [addContacts, options] = api.useAudienceUpdateMutation()

	return [
		async (body: Parameters<typeof addContacts>[0]) => {
			const { data: campaign } = await addContacts(body)

			if (campaign) {
				const nextSnack = structuredClone(NOTIFICATION['3.4a'])
				nextSnack.button.link = nextSnack.button.link.replace('{var}', body.id)

				snack(nextSnack)
			}

			return campaign
		},
		options
	] as const
}

export function useRun() {
	const { campaign, id } = useCurrent()
	const infoValue = campaign?.state

	const snack = notificationHooks.useSnack()

	const [run, options] = api.useRunCampaignMutation()
	return [
		async () => {
			const isStopped = infoValue === 'Stopped'

			const { data } = await run(id)

			if (!data) {
				return
			}

			snack(isStopped ? '3.9' : '3.6')

			const profile = await appConnector.auth.getSnailyProfile()
			if (profile.onBoarding && !profile.runningActivitiesEnabled) {
				await appConnector.auth.refreshAccessToken()
			}
		},
		options
	] as const
}
